var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"user-tag"},[_c('a-avatar',{attrs:{"src":_vm.user.avatar,"shape":"square"}}),_c('a',{staticClass:"user-name",attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.user.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }